export default __webpack_public_path__ + "static/media/ask_loader1.3fbded51.png";